import { Component, OnInit } from '@angular/core';

import { distinctUntilChanged, map } from 'rxjs/operators';

import WeekFacade from '@app/core/facades/week.facade';
import { FilterType } from '@app/shared/components/sub-header/filter-type.model';
import FilterChange from '@app/shared/filters/filter-change.model';
import FilterComponent from '@app/shared/filters/filter.component';

const SIZE = '110px';

@Component({
  selector: 'app-filter-week',
  templateUrl: '../filter.component.html',
  styleUrls: ['../filter.component.scss'],
})
export default class WeekFilterComponent extends FilterComponent implements OnInit {
  /** sets the label for Select */
  public readonly label = 'Week';
  /** Updates the value based on selection */
  public update(value: string, _: boolean): void {
    this._data.updateWeekName(value);
    this.valueChange.emit(new FilterChange(FilterType.Week, value));
  }

  /** Sets the width */
  public readonly width = SIZE;

  constructor(private readonly _data: WeekFacade) {
    super();
  }

  ngOnInit() {
    this.options$ = (!!this.config.transform ? this.config.transform(this._data.weeks$) : this._data.weeks$).pipe(
      distinctUntilChanged(),
      map((options: Array<{ [key: string]: string | number }>) =>
        options.map((option) => ({ label: `Week ${option.name}`, value: option.name }))
      )
    );

    this.initDefaultValues(this._data.weekName$);
  }
}
